import type { SVGProps } from "react";
const SvgNhMarker = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.5 8.5" {...props}>
        <path
            fill="#86a534"
            stroke="#fcfcfb"
            strokeWidth={0.6}
            d="M4.2.5c-1.2 0-2.6.8-2.6 2.6 0 1.3 2 4.1 2.6 4.8.6-.7 2.6-3.4 2.6-4.8C6.8 1.3 5.4.5 4.2.5z"
        />
    </svg>
);
export default SvgNhMarker;
